// import {LOCATION_CHANGE} from 'react-router-redux';

import {CLEAR_NOTIFICATIONS, HIDE_NOTIFICATION, SHOW_NOTIFICATION} from '../actions/notifications';

export default(state = [], action) => {
    switch (action.type) {
        case CLEAR_NOTIFICATIONS:
            // case LOCATION_CHANGE:
            return [];
        case HIDE_NOTIFICATION:
            return state.filter(n => n.key !== action.key);
        case SHOW_NOTIFICATION:
            return [
                action.payload, ...state
            ];
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/notifications.js